import React, { useRef, useState, useEffect } from "react";
import LocationIcon from "../../../assets/location_on.svg";
import EventIcon from "../../../assets/event.svg";
import PhoneIcon from "../../../assets/phone.svg";
import PhoneOverlayIcon from "../../../assets/phone.png";
import SmLogo from "../../../assets/admin/modules/sm-logo.png";
import Modal from 'react-modal';
import { useParams } from 'react-router-dom';
import { showLoading, hideLoading } from '../../../store/loading-reducer';
import { useDispatch, useSelector } from 'react-redux';
import { getPatientsProfileInfo, getLocationsByPhoneNumberId, inactivatePhoneNumberById, activatePhoneNumberById } from '../../../api/history';
import { formatPhoneNumberAsYouType, calculateDateDiff } from '../../../helpers/formatterHelper';
import { getTemplateList } from "../../../store/compose/actions";
import { GetALLAppointmentStatus, editAppointmentStatus } from '../../../api/inboxapi';
import { addInboxComposeMessageLog, getMessageLogHistory, getRefreshMessageLogHistory, profileCommunicationCheckbox } from '../../../store/messageInbox/actions';
import { formatBrowserDate, formatDateTimeForBrowserTimeZone } from '../../../components/common/DateTimeFormatter';
import { InactivatePhoneNumberConfirmationModal } from '../../../components/admin/InactivatePhoneNumberConfirmation';


function history() {
    const { phoneNumberId } = useParams();
    const dispatch = useDispatch();
    const [profileInfo, setProfileInfo] = useState([]);
    const { messageLogs } = useSelector((state) => state.inboxlists.messageLogList);
    const { maxMessageLogId } = useSelector((state) => state.inboxlists);
    const { templateList } = useSelector((state) => state.compose);
    const [messageQueueManual, setMessageQueueManual] = useState({ id: 0, englishContent: '', name: '', spanishContent: '' });
    const [locationArray, setLocationArray] = useState([]);
    const [appointmentStatus, setAppointmentStatus] = useState([]);
    const [selectedAppointmentStatus, setSelectedAppointmentStatus] = useState({ id: 0, appointmentStatusId: 0, patientId: 0 });
    const [error, setError] = useState(null);
    const [communicationCheckbox, setCommunicationCheckbox] = useState(false);
    const [isTwilioInactive, setIsTwilioInactive] = useState(false);
    const { isAdmin } = useSelector((state) => state.auth);
    const [showinactivatePhoneNumberModal, setInactivatePhoneNumberModal] = useState(false);
    const [patientPhoneNumberModal, setpatientPhoneNumberModal] = useState({});
    useEffect(() => {
        getUpComingAppointment();
    }, []);

    const getUpComingAppointment = () => {
        if (phoneNumberId > 0) {
            dispatch(showLoading());
            getPatientsProfileInfo(phoneNumberId).then((response) => {
                let responseData = response.data.data;
                setProfileInfo(responseData);
                const locations = [];
                responseData?.patients?.forEach((patient) => {
                    patient?.appointments?.forEach((apt) => {
                        const isLocationAlreadyAdded = locations.some((item) => item.id === apt?.location.id);
                        if (!isLocationAlreadyAdded) {
                            locations.push(apt?.location);
                        }
                    });
                });
                //setLocationArray(locations);
                setCommunicationCheckbox(responseData.inactiveByUser);
                setIsTwilioInactive(responseData.inactiveByTwilio);
                dispatch(hideLoading());
            });

            getLocationsByPhoneNumberId(phoneNumberId).then((response) => {
                const locationsData = response?.data?.data;
                setLocationArray(locationsData || []);
            });
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            const messagedata = {
                "phoneNumberId": phoneNumberId,
                "maxMessageId": 0
            }
            const response = await dispatch(getMessageLogHistory(messagedata));
            if (response.payload.success) {
                dispatch(hideLoading());
            }
        };
        dispatch(showLoading());
        fetchData();
    }, [dispatch, phoneNumberId, maxMessageLogId,]);

    useEffect(() => {
        const refreshData = async () => {
            const messagedata = {
                "phoneNumberId": phoneNumberId,
                "maxMessageId": maxMessageLogId
            }
            const response = await dispatch(getRefreshMessageLogHistory(messagedata));
            if (response.payload.success) {
                dispatch(hideLoading());
                chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
            }


            getPatientsProfileInfo(phoneNumberId).then((response) => {
                let responseData = response.data.data;
                setCommunicationCheckbox(responseData.inactiveByUser);
                setIsTwilioInactive(responseData.inactiveByTwilio);
            });
        };
        const intervalId = setInterval(() => {
            refreshData();
        }, 5000);
        return () => clearInterval(intervalId);
    }, [dispatch, phoneNumberId, maxMessageLogId, messageLogs]);

    useEffect(() => {
        GetALLAppointmentStatus().then((response) => {
            if (response.data.success) setAppointmentStatus(response.data.data);
        });
    }, []);

    const handleSelectChangeAppointmentStatus = (e, rowIndex, id, patientId) => {
        const appointmentStatusId = parseInt(e.target.value);
        const updatedAppointmentStatus = { ...selectedAppointmentStatus, appointmentStatusId: appointmentStatusId, id: id, patientId: patientId };
        setSelectedAppointmentStatus(updatedAppointmentStatus);
        // Call the function to update the appointment status
        handleEditAppointmentStatus(updatedAppointmentStatus);
    };

    const handleEditAppointmentStatus = (selectedAppointmentStatus) => {
        if (selectedAppointmentStatus != undefined && selectedAppointmentStatus != null && selectedAppointmentStatus.id > 0) {
            editAppointmentStatus({ options: { data: selectedAppointmentStatus } })
                .then((response) => {
                    if (response.data.success) {
                        getUpComingAppointment();
                    }
                    else { alert(response.data.message); }
                });
        }
    }
    const handleInactivatePhoneNumber = (item) => {
        if (item.id != undefined && item.id != null && item.id != 0) {           
            if (item.status !== 0) {
                activatePhoneNumberById(item.id)
                    .then((response) => {
                        if (response.data.success) {
                            getUpComingAppointment();
                        }
                        else {
                            alert(response.data.message);
                        }
                    });
            }
            else {
                inactivatePhoneNumberById(item.id)
                    .then((response) => {
                        if (response.data.success) {
                            getUpComingAppointment();
                        }
                        else {
                            alert(response.data.message);
                        }
                    });
            }
        }
    }
    const handleInactivatePhoneNumberTrigger = (id, phoneNumber, status) => {
        if (status !== 0) {
            setpatientPhoneNumberModal({ id: id, title: phoneNumber, body: 'Are you sure you want to activate this phone number?', btnText: 'Activate', status: status });
        }
        else {
            setpatientPhoneNumberModal({ id: id, title: phoneNumber, body: 'Are you sure you want to inactivate this phone number?', btnText: 'Inactivate', status: status });
        }
        setInactivatePhoneNumberModal(true);
    }

    const [messageSupport, setMessageSupport] = useState(false);
    const [imageWidth, setImageWidth] = useState(null);
    const [modalIsOpen, setIsOpen] = useState(false);
    const chatBoxRef = useRef();
    useEffect(() => {
        chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }, [messageLogs]);

    const adjustedWidth = imageWidth !== null ? imageWidth - 30 : null;
    useEffect(() => {
        const img = document.querySelector('.phone-img');
        const handleResize = () => {
            setImageWidth(img ? img.clientWidth : null);
        };
        const handleImageLoad = () => {
            handleResize();
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        img.addEventListener('load', handleImageLoad);
        return () => {
            window.removeEventListener('resize', handleResize);
            img.removeEventListener('load', handleImageLoad);
        };
    }, []);

    const messageRef = useRef(null);
    const toggleMessageSupport = () => {
        dispatch(getTemplateList());
        setMessageSupport(!messageSupport);
    };
    const handleOutsideClick = (event) => {
        if (messageRef.current && !messageRef.current.contains(event.target)) {
            setMessageSupport(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    const handleTemplateClick = (selectedTemplate) => {
        let body = ''; // Initialize body variable
        if (profileInfo?.patients?.length > 0) {
            if (profileInfo.patients.some(x => x.language.name === 'English')) {
                body = selectedTemplate.englishContent;
            } else if (profileInfo.patients.some(x => x.language.name === 'Spanish')) {
                body = selectedTemplate?.spanishContent;
            } else {
                body = selectedTemplate?.englishContent; // Default content if neither English nor Spanish
            }
        }
        const messageQueueData = {
            "Body": body,
            "PhoneNumberId": phoneNumberId,
            "TemplateId": selectedTemplate.id,
            PhoneNumber: {
                "Number": profileInfo.number,
            }
        }
        if (
            typeof messageQueueData.Body === 'string' &&
            messageQueueData.Body.trim() !== ''
        ) {

            dispatch(addInboxComposeMessageLog(messageQueueData)).then((response) => {
                if (response.payload.success) {
                    setIsOpen(false);
                    setMessageSupport(false);
                }
                else {
                    alert(response.payload.message);
                }
            });

        } else {
            setError(typeof messageQueueData.Body !== 'string' || messageQueueData.Body.trim() === '' ? 'Please enter message for send.' : null);
            setMessageQueueManual({ ...messageQueueManual, englishContent: '' })

        }
    }

    function openModal() {
        setIsOpen(true);
        setMessageSupport(!messageSupport);
    }
    function closeModal() {
        setIsOpen(false);
        setMessageSupport(!messageSupport);
        setError(null);
    }

    return (
        <>
            <InactivatePhoneNumberConfirmationModal
                show={showinactivatePhoneNumberModal}
                onClose={() => setInactivatePhoneNumberModal(false)}
                confirmInactivatePhoneNumber={handleInactivatePhoneNumber}
                model={patientPhoneNumberModal}
            />
            <div className="admin-page-wrap history admin-body-wrap">
                <div className="pageContainer">
                    <div className="admin-page-content">
                        <div className="admin-container position-relative">
                            <div className="history-flex-wrapper">
                                <div className="profile-information">
                                    <h1 className="admin-page-subheading color-black">Profile Information</h1>
                                    <div className="history-flex-cards">
                                        <div className="history-cards-content">
                                            <label className="card-label">Phone</label> 
                                            <p className="card-label-detail color-black">
                                                <span>
                                                    {formatPhoneNumberAsYouType(profileInfo && profileInfo?.number) || ''}
                                                </span>&nbsp;
                                                <a role="button" className="cursor-pointer card-label inactive-number" onClick={() => handleInactivatePhoneNumberTrigger(profileInfo && profileInfo?.id, profileInfo && profileInfo?.number, profileInfo && profileInfo?.status)}>{profileInfo && profileInfo?.status != 0 ? 'activate this number' : 'inactivate this number'}</a>
                                            </p>
                                        </div>
                                        <div className="history-cards-content">
                                            <label className="card-label">Contact</label>
                                            <p className="card-label-detail color-black">
                                                {profileInfo?.patients?.length > 0 && profileInfo.patients.map((patient) => (
                                                    <span key={patient?.id}><span>{`${patient?.firstName ?? ''} ${patient?.lastName ?? ''}`} </span><br /></span>
                                                ))}
                                            </p>
                                        </div>
                                        <div className="history-cards-content">
                                            <label className="card-label">Locations</label>
                                            <p className="card-label-data color-black">
                                                {locationArray && locationArray?.length > 0 && locationArray.map((location, index) => (
                                                    <span key={index}>
                                                        <span>{location?.name}</span><br />
                                                    </span>
                                                ))}
                                            </p>
                                        </div>
                                        <div className="history-cards-content">
                                            <label className="card-label">Communication</label>

                                            <label className={`select-communication ${isTwilioInactive ? 'communication-color' : ''}`}>
                                                <input type="checkbox"
                                                    id="Communication"
                                                    name="Communication"
                                                    value="Communication"
                                                    checked={communicationCheckbox}
                                                    onChange={(e) => {
                                                        if (isTwilioInactive === false) {
                                                            dispatch(profileCommunicationCheckbox({ phoneNumberId: phoneNumberId, communication: e.target.checked }));
                                                            setCommunicationCheckbox(e.target.checked);
                                                        }
                                                    }}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="card-label-data color-black">Opt out of all future communications</span>
                                            </label>
                                            {isTwilioInactive && <label className="card-label-message">Provider has stopped messaging to this number</label>}
                                        </div>
                                        <div className="history-cards-content">
                                            <label className="card-label">Language</label>
                                            {profileInfo?.patients?.length > 0 && profileInfo.patients.map((patient) => (
                                                <p className="card-label-data color-black" key={patient?.id}>{patient?.language?.name ?? ''} </p>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="history-notification-updates">
                                    <div className="history-chat-wrapper">
                                        <div className="history-chat-img">
                                            {messageSupport && (
                                                <div ref={messageRef} className="message-support-wrapper">
                                                    <div className="message-support-card">
                                                        {templateList?.length > 0 && templateList.map((messagetemplate) => (
                                                            messagetemplate?.name !== 'Manual' && (
                                                                <div key={messagetemplate?.id} className="cursor-pointer" onClick={() => { openModal(); setMessageQueueManual(messagetemplate); }}>
                                                                    <div className="message-box color-black">
                                                                        {messagetemplate?.name}
                                                                    </div>
                                                                </div>
                                                            )
                                                        ))}

                                                    </div>
                                                    {isAdmin && <button className="compose-manually cursor-pointer" onClick={() => {
                                                        openModal(); setMessageQueueManual({
                                                            ...messageQueueManual, englishContent: '', name: 'Manual',
                                                            id: templateList && templateList.find(x => x.name === 'Manual').id
                                                        });
                                                    }}>
                                                        Compose Manually
                                                    </button>}
                                                </div>
                                            )}
                                            {messageSupport ?
                                                <img src={PhoneOverlayIcon} alt="phone image" className="phone-img phone-overlay-img" />
                                                :
                                                <img src={PhoneIcon} alt="phone image" className="phone-img" />
                                            }
                                            <p className="history-note" style={{ width: adjustedWidth }}>PHI should not be shared using this platform</p>
                                        </div>

                                        <div className="messanger-wrapper" style={{ width: adjustedWidth }}>
                                            <div className="chat-message-list" id="messanger-wrapper-scroll" ref={chatBoxRef}>
                                                {messageLogs?.length > 0 && messageLogs.map((message) => (
                                                    message?.messageType?.name != 'Response From Patient' ? (
                                                        <div key={message?.id}>
                                                            <div className="right-message-wrapper">
                                                                <div className="chat-box-card">
                                                                    {message.messageStatus !== undefined && message.messageStatus != null && message.messageStatus.name === "Failed" ?
                                                                        <p className="message-date-time light-grey"><span className="material-symbols-rounded"> warning </span>{message.messageStatus.name}</p> :
                                                                        <p className="message-date-time light-grey">{formatDateTimeForBrowserTimeZone(message?.createdDate)}</p>}

                                                                    <div className="chat-message-card arrow-shape">
                                                                        <p className="color-white">
                                                                            {message?.body}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="userDP">
                                                                    <img src={SmLogo} alt="logo" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div key={message?.id} className="left-message-wrapper">
                                                            <div className="userDP">{`${profileInfo?.patients?.[0]?.firstName?.charAt(0) ?? ''}${profileInfo?.patients?.[0]?.lastName?.charAt(0) ?? ''}`}</div>
                                                            <div className="chat-box-card">
                                                                <p className="message-date-time light-grey"> {formatDateTimeForBrowserTimeZone(message?.createdDate)}</p>
                                                                <div className="chat-message-card arrow-shape">
                                                                    <p className="color-black">
                                                                        {message?.body}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                ))}

                                            </div>

                                            <div className="message-input-wrapper" onClick={toggleMessageSupport}>
                                                <p className="chat-input-box">Select SMS Response</p>
                                                <span className="material-symbols-rounded sms-response-btn">
                                                    expand_more
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div className="history-appointments">
                                    <h1 className="admin-page-subheading color-black">Upcoming Appointments</h1>
                                    {profileInfo?.patients?.length > 0 && profileInfo?.patients.map((patient) => (
                                        patient?.appointments?.length > 0 && patient?.appointments.map((apt, index) => {
                                            const { yearsDiff, monthsDiff } = calculateDateDiff(patient?.dateOfBirth)

                                            return (
                                                <div className="history-appointments-cards" key={apt?.id}>
                                                    <div key={apt?.id}>
                                                        <div className="history-appointments-flex-wrapper">
                                                            <div>
                                                                <h5 className="history-appointments-label color-black">{patient?.firstName} {patient?.lastName}</h5>
                                                                <p className="history-appointments-date light-grey">DOB: {patient?.dateOfBirth && (formatBrowserDate(patient?.dateOfBirth) ?? '')}   {`${yearsDiff && yearsDiff + 'y' || ''} ${monthsDiff && monthsDiff + 'mo' || ''}`}</p>
                                                            </div>
                                                            <div className="color-black">
                                                                <h5 className="history-appointments-label-heading">Appointment</h5>
                                                                <p className="history-appointments-number">{index + 1}</p>
                                                            </div>
                                                        </div>
                                                        <div className="history-appointments-location-detail">
                                                            <img src={LocationIcon} alt="fireSpot" />
                                                            <span className="location-heading light-grey">
                                                                {apt?.location?.name ?? ''}
                                                            </span>
                                                        </div>
                                                        <div className="history-appointments-location-detail">
                                                            <img src={EventIcon} alt="fireSpot" />
                                                            <span className="location-heading light-grey">{formatDateTimeForBrowserTimeZone(apt?.appointmentDateTime) ?? ''}</span>
                                                        </div>
                                                        <div className="history-appointments-card-actions">
                                                            {appointmentStatus.map((option, optionIndex) => (
                                                                <button className={(apt?.appointmentStatusId === option.id ? 'btn-power' : 'btn-normal')} key={optionIndex} value={option.id} onClick={(e) => handleSelectChangeAppointmentStatus(e, index, apt?.id, patient?.id)}>  {option.name}</button>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    ))}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={closeModal}
                >
                    {/*{profileInfo?.patients?.length > 0 && profileInfo.patients.map((patient) => (*/}
                    {/*    <p className="card-label-data color-black" key={patient?.id}>{patient?.language?.name ?? ''} </p>*/}
                    {/*))}*/}

                    <div className="chat-support-wrapper">

                        <div className="chat-support-box">
                            <div>
                                <button onClick={closeModal} className="modal-close cursor-pointer">
                                    <span className="material-symbols-rounded">
                                        close
                                    </span>
                                </button>
                            </div>
                            <textarea placeholder="Type here.."
                                value={
                                    profileInfo?.patients?.length > 0 &&
                                    (
                                        profileInfo.patients.some(x => x.language.name === 'English') ?
                                            messageQueueManual?.englishContent
                                            :
                                            profileInfo.patients.some(x => x.language.name === 'Spanish') ?
                                                messageQueueManual?.spanishContent
                                                :
                                                messageQueueManual?.englishContent // Default content if neither English nor Spanish
                                    )
                                }
                                onChange={(e) => {
                                    setMessageQueueManual(
                                        profileInfo?.patients?.length > 0 &&
                                        (
                                            profileInfo.patients.some(x => x.language.name === 'English') ?
                                                {
                                                    ...messageQueueManual, englishContent: e.target.value,
                                                    id: templateList && templateList.find(x => x?.name === 'Manual').id
                                                }
                                                :
                                                profileInfo.patients.some(x => x.language.name === 'Spanish') ?
                                                {
                                                    ...messageQueueManual, spanishContent: e.target.value,
                                                    id: templateList && templateList.find(x => x?.name === 'Manual').id
                                                }
                                                :
                                                {
                                                     ...messageQueueManual, englishContent: e.target.value,
                                                     id: templateList && templateList.find(x => x?.name === 'Manual').id
                                                } // Default content if neither English nor Spanish
                                        )

                                    );
                                    setError(null);
                                }}
                                readOnly={messageQueueManual.name !== 'Manual'}
                            />
                            {error && <p className="error-messagess chat-support-error">{error}</p>}
                            <div className="chat-support-btn-wrapper">
                                <button className="compose-manually cursor-pointer" onClick={() => handleTemplateClick(messageQueueManual)}>Send</button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        </>
    );
}

export default history;
